// ISO 4217 exponents: amountMinor = amount * 10^exponent
const CURRENCY_EXPONENTS = {
  MYR: 2, // Malaysian Ringgit (sen)
  VND: 0, // Vietnamese Dong (no subdivision)
  IDR: 2, // Indonesian Rupiah (sen)
};

const DEFAULT_EXPONENT = 2;

export function getCurrencyExponent(currencyCode) {
  if (!currencyCode) return DEFAULT_EXPONENT;
  const exp = CURRENCY_EXPONENTS[currencyCode.toUpperCase()];
  return exp !== undefined ? exp : DEFAULT_EXPONENT;
}

export function majorToMinor(amount, currencyCode) {
  const exp = getCurrencyExponent(currencyCode);
  return Math.round(amount * (10 ** exp));
}

export function minorToMajor(amountMinor, currencyCode) {
  const exp = getCurrencyExponent(currencyCode);
  if (exp === 0) return amountMinor;
  return amountMinor / (10 ** exp);
}

// CPI-977 (S4/S6): one money formatter for every Vietnam amount on screen. It was a local method
// on containers/Opportunities/Overview/Payment.jsx and open-coded twice more; the PO's requirement
// is byte-identity with the CRM. Behaviour is the promoted method's, unchanged.
export function formatMajorNumber(amount, currencyCode) {
  const exp = getCurrencyExponent(currencyCode);
  return new Intl.NumberFormat('en-MY', {
    minimumFractionDigits: exp,
    maximumFractionDigits: exp,
  }).format(amount || 0);
}

export function formatMinorNumber(amountMinor, currencyCode) {
  return formatMajorNumber(minorToMajor(amountMinor || 0, currencyCode), currencyCode);
}

// `VND 50,000,000`. The default code matches the promoted method's, so no call site changes.
export function formatMajorAmount(amount, currencyCode = 'VND') {
  return `${currencyCode} ${formatMajorNumber(amount, currencyCode)}`;
}

export function formatMinorAmount(amountMinor, currencyCode = 'VND') {
  return `${currencyCode} ${formatMinorNumber(amountMinor, currencyCode)}`;
}



// WEBPACK FOOTER //
// ./src/utils/numbers/currencyMinor.js